import styled from '@emotion/styled';
import { Theme } from '../theme';

const ThemeButton = styled('a')`
  display: flex;
  align-items: center;
  width: fit-content;

  background-color: ${Theme.colors.linksDesignElementsBaseColor};
  border: 1px solid ${Theme.colors.linksDesignElementsBaseColor};
  color: white;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;

  /* Strip annoying <a> styling */
  :visited,
  :hover,
  :active {
    color: white;
  }

  :hover {
    /* background-color: #98d343; */
    filter: brightness(110%);
  }

  i {
    font-size: 14px;
    line-height: 14px;
    margin-right: 10px;
    font-weight: 600;
  }
  @media (max-width: ${Theme.mobile.mobileBreakpointWidth}px) {
    font-size: 12px;
  }

  cursor: pointer;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.disabled ? '0.3' : '1')};
`;

export default ThemeButton;
